import { render, staticRenderFns } from "./pc-dropdown.vue?vue&type=template&id=a59a0c70&"
import script from "./pc-dropdown.vue?vue&type=script&lang=ts&"
export * from "./pc-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./pc-dropdown.vue?vue&type=style&index=0&id=a59a0c70&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports